import { Link } from "react-router-dom";

const stats = [
  { value: "3,200+", label: "在库漫画作品", icon: "ri-book-2-line" },
  { value: "58 万", label: "日活跃读者", icon: "ri-user-smile-line" },
  { value: "186 位", label: "签约作者", icon: "ri-pen-nib-line" },
  { value: "每日更新", label: "连载不间断", icon: "ri-refresh-line" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-primary-50">
      <div className="flex flex-col lg:flex-row lg:items-center gap-10">
        <div className="lg:w-1/2">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-label font-bold">
            <i className="ri-leaf-line"></i>
            关于蛙漫
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-label font-bold text-foreground-950 leading-snug">
            一只小小的青蛙，
            <br />
            背着一整片漫画的宇宙
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            蛙漫希望让「找到下一部想看的漫画」变得简单。我们把题材、更新动态、章节目录和资讯都整理得清清楚楚，无论你是想一口气补完一部完结作品，还是想追一部刚刚开更的新番，都能在这里安静地读完自己的一方天地。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/news"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label font-bold whitespace-nowrap transition-colors"
            >
              <i className="ri-newspaper-line"></i>
              看看最新资讯
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-label font-bold hover:border-primary-400 hover:text-primary-600 whitespace-nowrap transition-colors"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>

        <div className="lg:w-1/2 grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col gap-2 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100">
                <i className={`${stat.icon} text-lg text-accent-800`}></i>
              </span>
              <span className="text-xl md:text-2xl font-label font-bold text-foreground-950">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}